import {
  AutocompleteInput, Create, SimpleForm, TextInput, required,
} from 'react-admin';

import { releaseTypeChoices } from '@/Helper/DropdownChoices/dropdownChoices';

function AlbumCreate(props: object) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput
          source='spotifyUrl'
          label='Spotify URL'
          fullWidth
          validate={required()}
          helperText='Paste a Spotify album or track URL to create the album'
          placeholder='https://open.spotify.com/album/...'
        />
        <AutocompleteInput
          source='ReleaseType' label='Release Type'
          choices={releaseTypeChoices}
        />
      </SimpleForm>
    </Create>
  );
}

export default AlbumCreate;
